import { store } from '@utils/configStore'
import { optIntroductionVideoServiceOrderReducer } from './slices'

export const injectOPTIntrductionVideoServiceStore = () => store.injectReducer('optIntroductionVideoServiceOrder', optIntroductionVideoServiceOrderReducer)
